import { render, staticRenderFns } from "./PCReceiveManage.vue?vue&type=template&id=e87e4b3e&"
import script from "./PCReceiveManage.vue?vue&type=script&lang=js&"
export * from "./PCReceiveManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports